import React, { useEffect, useState } from "react"
import { Table } from "reactstrap"
import { fetchNodeData } from "utils/common-fetchData"

const chipStyle = (bg, fg) => ({
  padding: "4px 10px",
  borderRadius: "999px",
  background: bg,
  color: fg,
  border: `1px solid ${fg}30`,
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: 1.4,
  whiteSpace: "nowrap",
})

const CHIPS = [
  { key: "total", label: "Total", bg: "#f1e6f8", fg: "#5b2178" },
  { key: "approved", label: "Approved", bg: "#e8f7ee", fg: "#087a42" },
  { key: "unapproved", label: "Unapproved", bg: "#fbe9e9", fg: "#c62b2b" },
  { key: "pending", label: "Pending", bg: "#fff3df", fg: "#a95709" },
]

const formatDays = value => {
  const num = Number(value) || 0
  return Number.isInteger(num) ? num : num.toFixed(1)
}

// Month-wise leave summary (approved / unapproved / pending) for an employee
const LeaveStatsSummary = ({ userId, months = 6, refreshKey }) => {
  const [stats, setStats] = useState(null)
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (!userId) return
    const fetchStats = async () => {
      const res = await fetchNodeData(
        setLoading,
        `leaveStats/${userId}?months=${months}`,
        ""
      )
      setStats(res?.success ? res.data : null)
    }
    fetchStats()
  }, [userId, months, refreshKey])

  if (!userId) return null

  return (
    <div className="col-12 mb-2">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
        <h5 className="mb-0">Last {months} Months Leaves :</h5>
        <div className="d-flex gap-2 flex-wrap">
          {CHIPS.map(chip => (
            <span key={chip.key} style={chipStyle(chip.bg, chip.fg)}>
              {chip.label} : {formatDays(stats?.totals?.[chip.key])}
            </span>
          ))}
          <span
            style={chipStyle("#eaf2ff", "#245fbd")}
            title="Average leave days per month (cancelled leaves excluded)"
          >
            Avg / Month : {formatDays(stats?.average)}
          </span>
        </div>
      </div>
      <div
        className="table-responsive"
        style={{ maxHeight: "180px", overflowY: "auto" }}
      >
        <Table className="table table-sm mb-0 text-center">
          <thead
            className="bg-white"
            style={{ position: "sticky", top: 0, zIndex: 1 }}
          >
            <tr>
              <th className="header">Month</th>
              <th className="header">Total</th>
              <th className="header">Approved</th>
              <th className="header">Unapproved</th>
              <th className="header">Pending</th>
              <th className="header">Cancelled</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && !stats ? (
              <tr>
                <td colSpan={6}>Loading...</td>
              </tr>
            ) : stats?.data?.length ? (
              stats.data.map(row => (
                <tr key={row.month}>
                  <td>{row.month}</td>
                  <td className="fw-bold">{formatDays(row.total)}</td>
                  <td style={{ color: "#087a42" }}>
                    {formatDays(row.approved)}
                  </td>
                  <td style={{ color: "#c62b2b" }}>
                    {formatDays(row.unapproved)}
                  </td>
                  <td style={{ color: "#a95709" }}>
                    {formatDays(row.pending)}
                  </td>
                  <td className="text-muted">{formatDays(row.cancelled)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6}>No leave data found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default LeaveStatsSummary
